import { render } from "./LegalPopin.vue?vue&type=template&id=27b77668"
import script from "./LegalPopin.vue?vue&type=script&lang=js"
export * from "./LegalPopin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__